import { FC } from "react";
import { WalletConnect } from "../WalletConnect";
import { TvlBanner } from "../TvlBanner";
import { NetworkMismatchBanner } from "../NetworkMismatchBanner";
import type { NetworkMismatch } from "@/hooks/useNetworkCheck";

interface HeaderProps {
  view: "deposit" | "trade";
  onViewChange: (view: "deposit" | "trade") => void;
  networkMismatch?: NetworkMismatch;
  tradingEnabled?: boolean;
  hideLogo?: boolean;
}

export const Header: FC<HeaderProps> = ({ view, onViewChange, networkMismatch, tradingEnabled = true, hideLogo }) => {
  return (
    <header className="flex flex-wrap items-center justify-between gap-4 px-4 py-3 sm:px-6">
      <div className="flex min-w-0 items-center gap-4 sm:gap-5">
        {tradingEnabled && !hideLogo ? (
          <img
            src="/images/sugar-rush-wordmark.svg"
            alt="Sugar Rush"
            className="h-5 shrink-0 sm:h-6"
          />
        ) : (
          <span className="text-sm font-medium text-sr-neutral-300 shrink-0 sm:text-base" style={{ fontFamily: "var(--font-display)" }}>
            Gummiworm
          </span>
        )}
        <nav
          aria-label="Primary"
          className="flex items-center gap-1 rounded-full border border-white/[0.04] bg-sr-surface p-1"
        >
          {tradingEnabled && (
            <button
              onClick={() => onViewChange("trade")}
              className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                view === "trade"
                  ? "bg-sr-lemon-muted text-sr-espresso"
                  : "text-sr-neutral-300 hover:bg-white/[0.03] hover:text-white"
              }`}
              aria-current={view === "trade" ? "page" : undefined}
            >
              Exchange
            </button>
          )}
          <button
            onClick={() => onViewChange("deposit")}
            className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${
              view === "deposit"
                ? "bg-sr-lemon-muted text-sr-espresso"
                : "text-sr-neutral-300 hover:bg-white/[0.03] hover:text-white"
            }`}
            aria-current={view === "deposit" ? "page" : undefined}
          >
            Deposits
          </button>
        </nav>
        {networkMismatch && <NetworkMismatchBanner mismatch={networkMismatch} />}
      </div>
      <div className="flex items-center gap-4 sm:gap-5">
        <TvlBanner />
        <WalletConnect />
      </div>
    </header>
  );
};
